import React from 'react';
import Typography from '@mui/material/Typography';

export default function MyTypography({children, ...otherProps}) {
    return (
        <Typography {...otherProps}>{children}</Typography>
    );
}